$(document).ready(function() {
    $('[data-switch-pair-role="switcher"]').change(function (e){
        switcher_pair = $(e.target).data('switch-pair');
        switcher_value = $(e.target).val();

        $('[data-switch-pair-role="lamp"][data-switch-pair="' + switcher_pair + '"]').attr('disabled', 'disabled');
        $('[data-switch-pair-role="lamp"][data-switch-pair="' + switcher_pair + '"][data-switch-pair-on-value="'+ switcher_value +'"]').attr('disabled', null);
    });

    $('.validate-on-click').click(function(event){
        $(event.target).closest('form').find('[required]').next('.text-danger').remove();

        for (var i = 0, len = $(event.target).closest('form').find('[required]').length; i < len; i++) {
            required_field = $($(event.target).closest('form').find('[required]')[i]);

            if ($(required_field).is(":hidden")) {
                continue;
            }

            if ($(required_field.data('input-field')).length > 0) {
                value_field = $(required_field.data('input-field'));
            } else {
                value_field = required_field;
            }

            if (value_field.val()=='') {
                required_field.after($('#error_span').html());
                event.stopImmediatePropagation();
                event.preventDefault();
            };
        };
    });

    $('body').on('click', '.validate-files-ext', function(event){
        for (var i = 0, len = $(event.target).closest('form').find('input[data-files-ext-allow]').length; i < len; i++) {
            let file_field = $($(event.target).closest('form').find('input[data-files-ext-allow]')[i]);
            let allowed_extensions = $(file_field).data('files-ext-allow').split(',');

            if ($(file_field).val() == '') {
                continue;
            }

            if (allowed_extensions.indexOf($(file_field).val().split('.').pop().toLowerCase()) > -1) {
                continue;
            }

            event.stopImmediatePropagation();
            event.preventDefault();

            toastr.error($(file_field).data('files-ext-error-message'), null, { positionClass: 'toast-top-right', closeButton: true });
            break;
        };
    });

    $('body').on('click', '.validate-files-size', function(event){
        for (var i = 0, len = $(event.target).closest('form').find('input[data-files-max-size]').length; i < len; i++) {
            let file_field = $($(event.target).closest('form').find('input[data-files-max-size]')[i]);
            let max_file_size = $(file_field).data('files-max-size');

            if ($(file_field).val() == '') {
                continue;
            }

            if (file_field[0].files[0].size <= max_file_size) {
                continue;
            }

            event.stopImmediatePropagation();
            event.preventDefault();

            toastr.error($(file_field).data('files-max-size-error-message'), null, { positionClass: 'toast-top-right', closeButton: true });
            break;
        };
    });
});
